import React, { useEffect, useState } from "react";
import { PDFDocument } from "pdf-lib";
import mammoth from "mammoth";
import LoadingSpinner from "../../helpers/loadingspinner";
import stringSimilarity from "string-similarity";
import Swal from "sweetalert2";
import * as pdfjsLib from "pdfjs-dist";
import ConsultantLayout from "../../commonlayouts/consultantlayout";
import {  AddBenchCandidatesProfile_BulkImportwithDocs, GenerateContent,GetJobRoles } from "../../apiconstants/constants";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import axios from "axios";
import { Link } from "react-router-dom";
import { useCountry } from "../../contexts/countrycodecontext.js";
import Select from 'react-select';
const AddInternalCandidateFromDocument = () => {
  const guid = localStorage.getItem("guid");
  const token = localStorage.getItem('jwtToken');
  console.log("token",token)
  const [resumeText, setResumeText] = useState([]);
  const [text,setText] = useState("")
  const [jobResponsibilities, setJobResponsibilities] = useState("");
   const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
   const [extractedSkills, setExtractedSkills] = useState([]);
  const [extractedTextSkills, setExtractedTextSkills] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const { selectedCountry} = useCountry();
  const [jobRoles,SetJobRoles]=useState([{}]);
   const [selectedJobRole,setSelectedJobRole] = useState();   
   const [isComparing, setIsComparing] = useState(false);
     const [uploadedFiles, setUploadedFiles] = useState([]);
     
  const handleFileUpload = async (event) => {  
    const files = Array.from(event.target.files);
        setUploadedFiles(files);
    if (!files || files.length === 0) {
      setResumeText([]);
      return;
    }
    setShowDetails(false);
    setLoading(true);
    setIsComparing(true);

    const allowedFormats = ["application/pdf", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"];
    
    let extractedResumes = []; 

    for (const file of files) {
        if (!allowedFormats.includes(file.type)) {
            Swal.fire({
                position: 'center',
                icon: 'warning',
                title: 'Please upload only .pdf or .docx files',
                showConfirmButton: false,
                timer: 3000
            });
            continue; 
        }

        try {
            let extractedText = await extractTextFromFile(file);
            console.log(`Extracted Resume Text for ${file.name}:`, extractedText);
            const extractedDetails = await extractDetails(extractedText);
              extractedResumes.push({ fileName: file.name,
              resumeText: extractedText, ...extractedDetails });
        } catch (err) {
            console.error(`Error extracting text from ${file.name}:`, err);
           setIsComparing(false)
          }
    }
    setIsComparing(false)
    console.log("Extracted Resumes:", extractedResumes);
    setLoading(false)
    setResumeText(extractedResumes); 
};
const FetchJobroles=()=>
  {
    const GetapiUrl= `${GetJobRoles.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`; 
    const fetchJSON = async () => {
      const response = await fetch(GetapiUrl);
      let json = await response.json();
      SetJobRoles(json);
    }
    fetchJSON();
}
console.log("resumeText",resumeText.resumeText)
const extractDetails = async (text) => {
  console.log("80",text)
   try {
          const response = await axios.post(
         GenerateContent.APIURL,
         {
          prompt: `Extract all certifications mentioned in this resume text. 
            Return only a comma-separated list of certifications without extra text:\n\n${text}`,
      },
      { headers: {
        'Content-Type': 'application/json',
        'accept': '*/*',
        'Authorization': `Bearer ${token}` // Add the Authorization header       
         }}
          );
  
          console.log("API Response:", response);
  
          const responseContent = response.data?.response?.candidates?.[0]?.content?.parts?.[0]?.text || "";
          const certMatches = responseContent?.split(",").map((cert) => cert.trim());
        
        const extractedSkills = await analyzeSkill(text);
        const extractedDetails = await analyzeResumeWithJD(text);

        console.log("extractedSkills",extractedSkills,extractedDetails)

        return {
            skills: extractedSkills.length > 0 ? extractedSkills : ["Not Found"],
            certifications: certMatches?.length > 0 ? certMatches : ["Not Found"],
            name: extractedDetails.name,
            email:extractedDetails.email,
            phoneNumber:extractedDetails.phoneNumber,
            profilesummary: extractedDetails.profilesummary,
            experience:extractedDetails.experience,
            address:extractedDetails.address,
            linkedin:extractedDetails.linkedin,
        };
    } catch (err) {
        console.error("Error extracting certifications:", err);
        if (err.response && err.response.status === 401) {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Session expired! Please Login again',
            showConfirmButton: false,
            timer: 5000,
          }); 
          setTimeout(() => {
            window.location.href = "/Login"; // Redirect to login page
          }, 5000);
          return;
        }
        return {
            skills: extractedSkills.length > 0 ? extractedSkills : ["Not Found"],
            certifications: ["Not Found"],
        };
    }
};

  const extractTextFromFile = async (file) => {
    if (file.type === "application/pdf") {
      return extractTextFromPDF(file);
    } else if (file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
      return extractTextFromDOCX(file);
    } else {
      throw new Error("Unsupported file type. Please upload a PDF or DOCX.");
    }
  };

  const extractTextFromPDF = async (file) => {
    const arrayBuffer = await file.arrayBuffer();
    const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
    let extractedText = "";

    for (let i = 0; i < pdf.numPages; i++) {
        const page = await pdf.getPage(i + 1);
        const textContent = await page.getTextContent();
        extractedText += textContent.items.map(item => item.str).join(" ") + " ";
    }

    return extractedText;
};

  const extractTextFromDOCX = async (file) => {
    const reader = new FileReader();
    return new Promise((resolve, reject) => {
      reader.onload = async (event) => {
        const arrayBuffer = event.target.result;
        mammoth
          .extractRawText({ arrayBuffer })
          .then((result) => resolve(result.value))
          .catch((err) => reject(err));
      };
      reader.readAsArrayBuffer(file);
    });
  };
  let Guid="";

  const employerGuid = localStorage.getItem("employerGuid")
  const email = localStorage.getItem("email")
  
  const roleID = localStorage.getItem("roleID")
  
  if(roleID==3){
   Guid = employerGuid
  }
  else{
    Guid= guid
  }
  
  
  const handleSaveCandidates = async () => {
   console.log("188", resumeText)
      const formattedData = resumeText?.map((item) => ({
      userGuid: Guid,
      fullName: item?.name,
      email: item?.email, // Ensure correct email
      mobileNumber: item.phoneNumber?.toString(),
      dob: null,
      gender: "Male",
      address: item.address,
      jobRole: selectedJobRole ||'5',
      maritalStatus: "married",
      technicalSkill: item.skills?.join(", "),
      experience: item.experience,
      preferLocation: item.Country,
      workMode: "Hybrid",
      profileSummery: item.profilesummary,
      billRate: item.billRate,
      payRate: item.payRate,
      workAuthorizationandValidity: item.workAuthorizationandValidity,
      employerName: item.employerName,
      ssn: item.ssn?.toString(),
      passportNo: item.passportNo,
      tworefrencesfromrecentproject: item.tworefrencesfromrecentproject,
      linkedInUrl: item.linkedin,
      certifications: item.certifications?.join(", "),
      createdBy: email,
      countryID:selectedCountry,  
      CandidateType:"Internal Bench",    
    }));
   const formDataToSend = new FormData();

formDataToSend.append("CandidatesJson", JSON.stringify(formattedData)); // JSON data
console.log("324",uploadedFiles)
uploadedFiles.forEach((file) => {
  formDataToSend.append("ResumeFiles", file, file.name); // ✅ Add each file
});
    try {
      const response = await axios.post(
        AddBenchCandidatesProfile_BulkImportwithDocs.APIURL,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
  
  
  if (response.data.candidates && Array.isArray(response.data.candidates)) {
    const messages = response.data.candidates?.map((candidate) => {
      const { email, statusMessage } = candidate;
 if (email === "N/A") {
      return `❌ <strong>Email doesn’t exist</strong> for that candidate.`;
    } 
      else if (statusMessage === 'Inserted') {
        return `✅ <strong>${email}</strong> added successfully.`;
      } else if (statusMessage === 'Duplicate or Already Exists') {
        return `⚠️ <strong>${email}</strong> already exists.`;
      } else {
        return `ℹ️ <strong>${email}</strong>: ${statusMessage}`;
      }
    });

    Swal.fire({
      icon: 'info',
      title: 'Candidate Upload Summary',
      html: messages.join('<br>'),
      showConfirmButton: true,
    });
  } else {
    Swal.fire({
      icon: 'error',
      title: 'Unexpected response format.',
      text: 'Please check the server response.',
      showConfirmButton: true,
    });
  }



    } catch (error) {
      console.error("Error saving candidates:", error);
    }
  };
   useEffect(()=>{
             
        FetchJobroles();
        
    },[selectedCountry])
const deleteResume = (indexToDelete) => {
  const updated = [...resumeText];
  updated.splice(indexToDelete, 1);
  setResumeText(updated);
};

  const analyzeSkill = async (resumeText) => {
    if (!resumeText) {
      setError("Please upload a resume.");
      return;
    }
    try {
      const response = await axios.post(
    GenerateContent.APIURL,
    {
        prompt:`Extract all skills from the following text. Follow these guidelines:

                1. *Extract All Skills:*  
                  - Extract all skills explicitly listed under the "Skills" or "Technical Skills" section.  
                  - Also extract any additional skills mentioned under other sections such as experience, projects, certifications, education, or achievements.  
                  - Capture programming languages, frameworks, tools, platforms, DevOps tools, business skills, and industry-specific skills.  

                2. *Hidden and Embedded Skills:*  
                  - If a skill is mentioned within a sentence or as part of a project description, extract it.  
                  - Example: "Worked on Docker for containerization" → Extract *Docker* as a skill.  

                3. *Normalization:*  
                  - If the skill is mentioned under a different name or alias, normalize it to the standard term (e.g., “Azure Databricks” → “Databricks”, “Microsoft Azure” → “Azure”).  

                4. *DevOps and Monitoring Tools:*  
                  - Ensure DevOps tools like *Jenkins*, *Terraform*, *Docker*, *CI/CD*, and monitoring tools like *Grafana* and *Prometheus* are included if present.  

                5. *Format Output:*  
                  - Return a single, comma-separated list of all extracted skills (including both explicitly listed and inferred skills).  
                  - Remove duplicates and ensure consistent formatting.  

                6. *Retry and Match:*  
                  - If the skills section is missing or unclear, attempt to extract skills from other sections or provide the closest possible match.  
                  - If you suspect that some skills were not captured, retry extraction automatically.  

                7. *Exclude:*  
                  - Exclude soft skills (e.g., communication, leadership, problem-solving).  
                  - Exclude job responsibilities and achievements.  
                  - Exclude processes (e.g., Agile, Performance Tuning, Cost Optimization).  

                ### Examples of Expected Skills:
                - Programming: Python, Java, C++, SQL  
                - Platforms: AWS, Azure, GCP, Kubernetes  
                - DevOps: Jenkins, Docker, Terraform, Grafana  
                - Data Tools: Spark, Hive, Snowflake, Databricks  
                - Industry Skills: Financial Analysis, Healthcare Compliance 
### Resume:
${resumeText}`,
    },
  { headers: {
  'Content-Type': 'application/json',
  'accept': '*/*',
  'Authorization': `Bearer ${token}` // Add the Authorization header       
   }}
);

console.log("API Response:", response);

const responseContent = response.data?.response?.candidates?.[0]?.content?.parts?.[0]?.text || "";
const extractedSkills = responseContent?.split(",")?.map((skill) => skill.trim());
      setExtractedSkills(extractedSkills);
      return extractedSkills;
    } catch (err) {
      if (err.response && err.response.status === 401) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Session expired! Please Login again',
          showConfirmButton: false,
          timer: 5000,
        }); 
        setTimeout(() => {
          window.location.href = "/Login"; // Redirect to login page
        }, 5000);
        return;
      }
      console.error("Error extracting skills:", err);
      setError("Failed to extract skills.");
    }
  };

  const analyzeResumeWithJD = async (resumeText) => { 
 
    try {
      const response = await axios.post(
        GenerateContent.APIURL,
        {
            prompt: `You are an expert resume analysis engine.
  
  Compare the following **Resume** and **Job Description**, and return a JSON object with exactly the following fields only:
  
  1. **name**: Full name extracted from the resume.
  2. **email**: Email address from the resume.
  3. **phoneNumber**: Phone number from the resume.
  4. **matchedSkills**: A list of *technical skills* found in both the resume and the job description.
  5. **unmatchedSkills**: A list of *key technical skills* present in the job description but NOT found anywhere in the resume.
  6. **totalJDskills**: The total number of unique skills extracted from the job description.
  7. **profilesummary**: The candidate's profile summary or professional overview as written in the resume.
8. **experience**: Calculate total professional experience using all employment periods listed in the resume. For any job with an end date marked as "Present", "Till Date", or similar, use today's date (assume current date is June 16, 2025) as the end date. The result should be formatted as "X years Y months", and must be accurate.
9. **address**: Physical address or location mentioned in the resume.
10. **linkedin**: LinkedIn profile URL if mentioned in the resume. 

  ### Resume:
  ${resumeText}
  
  ### Job Description:
  ${jobResponsibilities}
  
  ### Output Format (JSON Only):
  {
    "name": "Full Name",
    "email": "example@email.com",
    "phoneNumber": "1234567890",
    "matchedSkills": ["Skill1", "Skill2"],
    "unmatchedSkills": ["SkillA", "SkillB"],
    "totalJDskills": 10,
     "profilesummary": "Candidate's summary goes here...",
  "experience": "3 years 2 months",
  "address": "City, State, Country",
  "linkedin": "https://linkedin.com/in/username"
  }`,
        },
        { headers: {
          'Content-Type': 'application/json',
          'accept': '*/*',
          'Authorization': `Bearer ${token}` // Add the Authorization header       
        }}
    
    );

    console.log("API Response:", response);

    // Extract response content
    const responseText = response.data?.response?.candidates?.[0]?.content?.parts?.[0]?.text || "";
     console.log("Extracted Text:", responseText);
  
      // Clean up markdown backticks before parsing
      const sanitizeJsonResponse = (text) => {
        return text.replace(/```json\s*|```/g, "").trim();
      };
  
      try {
        const cleanedJson = sanitizeJsonResponse(responseText);
        const parsedJson = JSON.parse(cleanedJson);
        const result = {
          name: parsedJson.name || "N/A",
          email: parsedJson.email || "N/A",
          phoneNumber: parsedJson.phoneNumber || "N/A",
          profilesummary: parsedJson.profilesummary || "N/A",
          experience: parsedJson.experience || "N/A",
          address: parsedJson.address || "N/A",
          linkedin: parsedJson.linkedin || "N/A"
        };
    
        console.log("Processed Result:", result);
        return result; // ✅ Returning full AI response
  
      } catch (jsonError) {
        console.error("Error parsing JSON response:", jsonError);
        return {
          error: "Failed to parse AI response",
          rawResponse: responseText
        };
      }
    } catch (err) {
      if (err.response && err.response.status === 401) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Session expired! Please Login again',
          showConfirmButton: false,
          timer: 5000,
        }); 
        setTimeout(() => {
          window.location.href = "/Login"; // Redirect to login page
        }, 5000);
        return;
      }
      console.error("Error calling AI API:", err);
      return null;
    }
  };
  
  const handleDetails = ()=>{
    if (resumeText.length==0) {
      Swal.fire({
          position: 'center',
          icon: 'warning',
          title: 'Please upload atleast one .pdf or .docx files',
          showConfirmButton: false,
          timer: 3000
      });
      return
    }
    else{
    setShowDetails(true)
    }
  }

  const jobRoleOptions = jobRoles.map((item) => ({
  value: item.jobRoleId,
  label: item.jobRole,
}));
  
  return (
    <ConsultantLayout>
  <div style={{ padding: "20px", display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
         <div style={{ display: 'flex', alignItems: 'center' }} className="mb-5">
      <Link to="/Employer/InternalBench">
        <i className="fa fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: '10px', marginTop: 8}} aria-hidden="true"></i>
      </Link>
      <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: 8 }}> Add Internal Candidates</h2>
    </div>
{isLoading ? (
  <div style={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh", // Ensures it takes full screen height
    width: "100%",
  }}>
    <LoadingSpinner />
  </div>
) : (
  <>
    <h5 style={{ color: "#00a7ac" }}>Upload Resumes</h5>
    <input
      className="form-control basic-form"
      type="file"
      accept=".pdf, .docx"
      multiple
      onChange={handleFileUpload}
      style={{ marginBottom: "10px" }}
    />

    {loading && <p>Processing Resumes... Please wait.</p>}

  
<OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Job Role</Tooltip>)}>    

{/* <select   className={`form-control mt-3 `} style={{height:50 ,borderRadius:15,fontSize:12}} onChange={(e)=>setSelectedJobRole(e.target.value)} >
<option value="">Select Job Role</option>
{
  jobRoles.map((item,index)=>
  {
    return(

   <option key={index}  value={item.jobRoleId}>{item.jobRole}</option>

    );
  }
  
  )
}
</select> */}
  <Select
      options={jobRoleOptions}
      onChange={(selectedOption) => setSelectedJobRole(selectedOption ? selectedOption.value : '')}
      placeholder="Select Job Role"
      className="mt-3 w-100"
      styles={{
        control: (base) => ({
          ...base,
          height: 50,
          borderRadius: 15,
          fontSize: 12,
        }),
      }}
    />
</OverlayTrigger>

  <button onClick={handleDetails} className="btn btn-primary mt-3"     disabled={isComparing}
>    
       {isComparing ? "Processing..." : "Generate Candidates"}
    </button>

    {showDetails && resumeText.length > 0 ? (
      <div>
        <div className="d-flex justify-content-between mt-2">
          <h4 style={{ color: "#00a7ac", marginTop: "20px" }}>Extracted Details</h4>
          <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip">save</Tooltip>}>
            <button className="btn btn-primary" style={{ height: 40 }} onClick={handleSaveCandidates}>
              Save Candidates
            </button>
          </OverlayTrigger>
        </div>

        {resumeText?.map((resume, index) => {
         const isEmailMissing = !resume?.email || resume.email === "N/A";


          return (
            <div
              key={index}
              style={{
                marginTop: "20px",
                width: "100%",
                padding: "15px",
                border: "1px solid #ccc",
                borderRadius: "8px",
                position: "relative"
              }}
            >
              <p style={{ fontSize: "18px" }}><strong>File:</strong> {resume.fileName}</p>
              <p style={{ fontSize: "18px" }}><strong>Name:</strong> {resume?.name}</p>
              <p style={{ fontSize: "18px" }}>
                <strong>Email:</strong>{" "}
                {resume?.email || <span style={{ color: "red" }}>Email Not Found</span>}
              </p>
              <p style={{ fontSize: "18px" }}><strong>Phone Number:</strong> {resume?.phoneNumber}</p>
              <p style={{ fontSize: "18px" }}>
                <strong>Profile Summary:</strong>{" "}
                {resume?.profilesummary || <span style={{ color: "red" }}>Profile Summary Not Found</span>}
              </p>
                <p style={{ fontSize: "18px" }}>
                <strong>Experience:</strong>{" "}
                {resume?.experience || <span style={{ color: "red" }}>Experience Not Found</span>}
              </p>
                 <p style={{ fontSize: "18px" }}>
                <strong>Address:</strong>{" "}
                {resume?.address || <span style={{ color: "red" }}>Address Not Found</span>}
              </p>
                 <p style={{ fontSize: "18px" }}>
                <strong>Linkedin URL:</strong>{" "}
                {resume?.linkedin || <span style={{ color: "red" }}>Linkedin URL Not Found</span>}
              </p>
              <p style={{ fontSize: "18px" }}>
                <strong>Resume Skills:</strong>{" "}
                {resume?.skills?.length > 0
                  ? resume?.skills?.sort((a, b) => a.localeCompare(b)).join(", ")
                  : "Not Found"}
              </p>
              <p style={{ fontSize: "18px" }}>
                <strong>Candidates Certifications:</strong>
                <ul>
                  {resume?.certifications?.map((cert, i) => (
                    <li key={i}>{cert}</li>
                  ))}
                </ul>
              </p>

              {isEmailMissing && (
                <button
                  className="btn btn-danger"
                  style={{ position: "absolute", top: 15, right: 15 }}
                  onClick={() => deleteResume(index)}
                >
                  Delete Resume
                </button>
              )}
            </div>
          );
        })}
      </div>
    ) : null}
  
  </>
)}
</div>
    </ConsultantLayout>
  )}



export default AddInternalCandidateFromDocument;